@if (widgetProperties) {
<div
  [formGroup]="beneficiaryForm"
  class="finxForm"
  [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
>
  <!-- Reusable flag rendering template (used across options and selected items) -->
  <ng-template #flagTemplate let-flagHtml>
    @if (widgetProperties?.['showCurrencyFlags']) {
    <span class="d-contents" [innerHTML]="flagHtml | safeHtml"></span>
    }
  </ng-template>

  <!-- Option template: displays flag + title for dropdown options -->
  <ng-template #optionTemplate let-item>
    <span class="d-inline-flex gap-2">
      <ng-container
        *ngTemplateOutlet="flagTemplate; context: { $implicit: item.currencyFlag }"
      ></ng-container>
      <span>{{ item.title }}</span>
    </span>
  </ng-template>

  <!-- Template for selected country: flag + title -->
  <ng-template #customCountrySelectedOption>
    <span class="d-inline-flex gap-2">
      <ng-container
        *ngTemplateOutlet="flagTemplate; context: { $implicit: selectedCountryOption.currencyFlag }"
      ></ng-container>
      <span>{{ selectedCountryOption?.title }}</span>
    </span>
  </ng-template>

  <!-- Template for selected currency: flag + title -->
  <ng-template #customCurrencySelectedOption>
    <span class="d-inline-flex gap-2">
      <ng-container
        *ngTemplateOutlet="flagTemplate; context: { $implicit: selectedCurrencyOption.currencyFlag }"
      ></ng-container>
      <span>{{ selectedCurrencyOption?.title }}</span>
    </span>
  </ng-template>

  <!-- Reusable dropdown rendering template for country/currency fields -->
  <ng-template
    #renderSelect
    let-id="id"
    let-options="options"
    let-formControlName="formControlName"
    let-label="label"
    let-selectedOption="selectedOption"
    let-optionValueKey="optionValueKey"
    let-customSelectedOptionTemplate="customSelectedOptionTemplate"
  >
    <div class="pointer-events-none">
      <finxone-select-dropdown
        [id]="id"
        [options]="options"
        [formControlName]="formControlName"
        [optionLabelKey]="'title'"
        [optionValueKey]="optionValueKey"
        [appendToBody]="true"
        [searchEnabled]="true"
        [isScrollable]="isScrollable"
        [isScrollPeekEnabled]="isScrollPeekEnabled"
        [visibleItemsCount]="visibleItemsCount"
        [menuDirection]="menuDirection"
        [validationConfig]="beneficiaryFormService.getValidationConfig(widgetInputFieldValidation)"
        [formControlInvalid]="
          !!(beneficiaryForm.get(formControlName)?.invalid && beneficiaryForm.get(formControlName)?.touched)
        "
        [selectedOption]="beneficiaryForm.get(formControlName)?.value ?? ''"
        [label]="label"
        [customOptionTemplate]="optionTemplate"
        [customSelectedOptionTemplate]="customSelectedOptionTemplate"
        (selectionChange)="onSelectionChange()"
      ></finxone-select-dropdown>
    </div>
  </ng-template>

  @if (widgetProperties?.['isCountryVisible']) {
  <!-- Country dropdown using reusable template -->
  <ng-container
    *ngTemplateOutlet="renderSelect;
    context: {
    id: countryFormControlName,
    options: countryList,
    formControlName: countryFormControlName,
    label: widgetProperties?.['countryLabel'],
    selectedOption: selectedCountryOption,
    optionValueKey: 'key',
    customSelectedOptionTemplate: customCountrySelectedOption,
  }"
  ></ng-container>
  } @if (widgetProperties?.['isCurrencyVisible']) {
  <!-- Currency dropdown using reusable template -->
  <ng-container
    *ngTemplateOutlet="renderSelect;
    context: {
    id: currencyFormControlName,
    options: currencyCodes,
    formControlName: currencyFormControlName,
    label: widgetProperties?.['currencyLabel'],
    selectedOption: selectedCurrencyOption,
    optionValueKey: 'value',
    customSelectedOptionTemplate: customCurrencySelectedOption,
  }"
  ></ng-container>
  }
</div>
}
